module.exports = __webpack_public_path__ + "img/dev_2.20717bf4.png";